import { makeBetterEnum } from './betterEnum';

export const ApprovalTargetLockState = makeBetterEnum(
  'Locked',
  'UnlockRequested',
  'Unlocked'
);
export type ApprovalTargetLockState =
  (typeof ApprovalTargetLockState)[keyof typeof ApprovalTargetLockState];
